import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, Input, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { DxPivotGridComponent } from "devextreme-angular";


@Component({
    selector: 'pivotcomponente',
    templateUrl: './pivot.component.html',
    styleUrls: ['./pivot.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class pivotcomponent implements AfterViewInit{
    consulta!: boolean;
    @Input() info!: any;

    private columnMaxValues: Map<string, number> = new Map();

    @ViewChild('general', {static: false}) pivot!: DxPivotGridComponent;
    @ViewChild('faltante', {static: false}) pivotf!: DxPivotGridComponent;

    constructor(private cdr: ChangeDetectorRef,private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
      this.info.gerardata = this.GenerarData(this.info.respuesta);
      this.info.generardatafaltante = this.GenerarDataFaltante(this.info.faltante);
      this.cdr.detectChanges();

      this.info.maxrespuesta = Math.max(...this.info.respuesta.map((item:any) => parseFloat(item.numero)));
      this.info.maxrespuesta  = parseFloat(this.info.maxrespuesta).toFixed(2);
    }

    GenerarDataFaltante(data: any):any {
        let datatablefaltante = {
            fields: [{
                caption: 'Respuesta',
                dataField: 'respuesta',
                area: 'row',
                sortingMethod: function (a:any, b:any) {
                }
            }, {
                dataField: 'relacion',
                area: 'column',
            }, {
                dataField: 'numero',
                dataType: 'number',
                area: 'data',
                format: {type: "largeNumber", precision: 2},
                summaryType: 'custom',
                calculateCustomSummary: (options: any) => {
                    switch(options.summaryProcess) {
                        case "calculate":
                            this.pivot.instance.beginUpdate()
                            this.pivotf.instance.beginUpdate()
                            if(options.value > 0){
                                let valor = parseFloat(options.value).toFixed(2);
                                options.totalValue = valor+"%";
                            }else{
                                options.totalValue = 0+"%";
                            }
                            break;
                    }
                }
            }],
            store: data,
        };
        return datatablefaltante;
    }

    GenerarData(data: any):any {
        let datatable = {
            fields: [{
                caption: 'Respuesta',
                dataField: 'respuesta',
                area: 'row',
                sortingMethod: function (a:any, b:any) {
                }
            }, {
                dataField: 'relacion',
                area: 'column',
            }, {
                dataField: 'numero',
                dataType: 'number',
                area: 'data',
                format: {type: "largeNumber", precision: 2},
                summaryType: 'custom',
                calculateCustomSummary: (options: any) => {
                    switch(options.summaryProcess) {
                        case "calculate":
                            this.pivot.instance.beginUpdate()
                            this.pivotf.instance.beginUpdate()
                            if(options.value > 0){
                              let valor = parseFloat(options.value).toFixed(2);
                                options.totalValue = valor+"%";
                            }else{
                                options.totalValue = 0+"%";
                            }
                            break;
                    }
                }
            }],
            store: data,
        };

        return datatable;
    }

    onCellPreparedFaltante(e:any, data:any) {

      if (e.area === "column") {
        if (e.cell.text === 'Jefe') {
          e.cellElement.innerText = 'Subordinado';
        }
        if (e.cell.text === 'Subordinado') {
          e.cellElement.innerText = 'Jefe';
        }
      }
        if(e.area == "row" && e.cell.type == 'D'){
          let color = data.find((x:any)=>x.respuesta == e.cell.text);
          if(color){
              e.cellElement.bgColor = color.color;
          }
          e.cellElement.style = 'color: black;';
        }
        if (e.area == "row" && e.columnIndex == 0 && e.cell.type == 'GT') {
           e.cellElement.textContent = "Preguntas enviadas"
        }

        if(e.area == "data" && e.cell.columnType == 'D' && e.cell.rowType == 'D'){
            e.cellElement.style = 'text-align: center;'
        }
        if(e.area == "data" && e.cell.rowType == 'GT'){
            let total = data.find((x:any)=>x.relacion == e.cell.columnPath[0]);
            if(total){
                e.cellElement.textContent = ''+total.pregunta;
                e.cellElement.style = 'text-align: center;'
            }
        }
    }

    onCellPrepared(e:any, data:any, max:any) {
       if (e.area === "column") {
        if (e.cell.text === 'Jefe') {
          e.cellElement.innerText = 'Subordinado';
        }
        if (e.cell.text === 'Subordinado') {
          e.cellElement.innerText = 'Jefe';
        }
      }
      if (e.area === "row" && e.cell.type === 'D') {
        let color = data.find((x: any) => x.respuesta == e.cell.text);
        if (color) {
          e.cellElement.bgColor = color.color;
        }
        e.cellElement.style = 'color: black;';
      }
      if (e.area === "row" && e.columnIndex === 0 && e.cell.type === 'GT') {
        e.cellElement.textContent = "Evaluadores";
      }
      if (e.area === "data") {
        if (e.cell.columnType === 'D' && e.cell.rowType === 'D') {
          let estilo = 'text-align: center;';
          const columnId = this.getColumnIdentifier(e.cell);
          if (!this.columnMaxValues.has(columnId)) {
            const columnMax = this.calculateColumnMax(e, data);
            this.columnMaxValues.set(columnId, columnMax);
          }
          const cellValue = this.parseValue(e.cell.text);
          const columnMax = this.columnMaxValues.get(columnId) ?? 0;
          if (columnMax > 0) {
            if (cellValue === parseFloat(max)) {
              e.cellElement.bgColor = '#caeeb1';
              estilo += ' font-weight: bold;';
            } else if (cellValue === columnMax) {
              e.cellElement.bgColor = '#caeeb1';
              estilo += ' font-weight: bold;';
            }
          }
          e.cellElement.style = estilo;
        }
        if (e.cell.rowType === 'GT') {
          let total = data.find((x: any) => x.relacion === e.cell.columnPath[0]);
          if (total) {
            e.cellElement.textContent = '' + total.evaluadores;
            e.cellElement.style = 'text-align: center;';
          }
        }
      }
    }

    private getColumnIdentifier(cell: any): string {
      return cell.columnPath ? cell.columnPath.join('_') : '';
    }

    private parseValue(value: string): number {
      return parseFloat(parseFloat(value.replace('%', '')).toFixed(2));
    }

    private calculateColumnMax(e: any, data: any[]): number {
      let maxValue = -Infinity;
      const columnPath = e.cell.columnPath;
      const columnField = columnPath[columnPath.length - 1];

      // Filtrar los datos por la columna actual
      const columnData = data.filter(item => {
        return item.relacion === columnPath[0]; // Ajusta esto según tu estructura de datos
      });

      // Encontrar el valor máximo en los datos filtrados
      columnData.forEach(item => {
        if (item && item.numero) {
          const value = this.parseValue(item.numero.toString());
          if (!isNaN(value) && value > maxValue) {
            maxValue = value;
          }
        }
      });

      // Si el máximo es -Infinity, significa que no encontramos valores válidos
      if (maxValue === -Infinity) {
        return 0;
      }

      // Redondeamos el valor máximo a dos decimales
      return parseFloat(maxValue.toFixed(2));
    }

}
